module.exports = __webpack_public_path__ + "img/in-screen-front.92019f7b.png";